;const LAVAMOAT = Object.create(null);
;/*root*/;
LAVAMOAT['root'] = ("$root$");
;/*idmap*/;
LAVAMOAT['idmap'] = ([["$root$",[4453,32160,60665,17655,85518,5722,42925,22302,54133,35121,2790,62954,33973,31140,66850,13299,78962,42278,50383,68792,1408,38163,94007,16616,82082,86704,57880,66256,29187,54639,27604,54456,52473,94416,14916,32832,8737,59062,11946,61848,30462,12809,84906,56485,66865,17566,74315,60971,73987,86692,8513,12977,60740,34279,80750,13425,88072,96262,64214]],["react",[96540,29869,74848,29698]],["node-stdlib-browser",[49184]],["react-dom",[5338,31247,40961,6221]],["react-dom>scheduler",[69982,4477]],["buffer",[48287]],["buffer>base64-js",[67526]],["buffer>ieee754",[251]],["@hathor/snap-utils",[97291,42702,97490,61705,92953,20876,31540]],["@radix-ui/react-dialog",[60990]],["@radix-ui/react-toast>@radix-ui/primitive",[9957]],["@radix-ui/react-slot>@radix-ui/react-compose-refs",[91071]],["@radix-ui/react-toast>@radix-ui/react-context",[62133]],["@radix-ui/react-dialog>@radix-ui/react-id",[18723]],["@radix-ui/react-toast>@radix-ui/react-use-layout-effect",[88200]],["@radix-ui/react-toast>@radix-ui/react-use-controllable-state",[81351]],["@radix-ui/react-toast>@radix-ui/react-dismissable-layer",[58666]],["@radix-ui/react-toast>@radix-ui/react-primitive",[12579]],["@radix-ui/react-slot",[33362]],["@radix-ui/react-toast>@radix-ui/react-use-callback-ref",[10263]],["@radix-ui/react-toast>@radix-ui/react-dismissable-layer>@radix-ui/react-use-escape-keydown",[92129]],["@radix-ui/react-dialog>@radix-ui/react-focus-scope",[18531]],["@radix-ui/react-toast>@radix-ui/react-portal",[13656]],["@radix-ui/react-toast>@radix-ui/react-presence",[7971]],["@radix-ui/react-dialog>@radix-ui/react-focus-guards",[61463]],["@radix-ui/react-dialog>aria-hidden",[58241]],["@radix-ui/react-dialog>react-remove-scroll",[18590,77427,67570,33198,70047,76560,25406]],["@radix-ui/react-dialog>aria-hidden>tslib",[31635]],["@radix-ui/react-dialog>react-remove-scroll>react-remove-scroll-bar",[34720,37433,10434,93812]],["@radix-ui/react-dialog>react-remove-scroll>use-sidecar",[57309,30635]],["@radix-ui/react-dialog>react-remove-scroll>use-callback-ref",[68728,37656,78536]],["@radix-ui/react-dialog>react-remove-scroll>react-style-singleton",[34294,22797,28439,40571]],["@radix-ui/react-dialog>react-remove-scroll>react-style-singleton>get-nonce",[36667]],["clsx",[34164]],["tailwind-merge",[50856]],["lucide-react",[48697,26203,50576,54991,33552,418,37946,18931,72250,50802,80827,73291,33167,75107,55042,35404,30684,89230,97213,3707,3160,8723,46816,45773,79804,72102,90232,27235,44471]],["class-variance-authority",[22732]],["@hathor/wallet-lib",[40189,59446,63028,16548,79223,86305,1236,10040,95762,66427,23653,14067,89423,46539,21382,6329,4880,40505,42306,9285,23632,88976,40842,60546,32449,37160,27214,20834,35865,99021,7912,58112,5411,90331,66169,39171,52588,41751,51423,85289,51987,27524,81033,2995,83170,30216,39327,4046,48131,45451,25649,55103,14651,96118,29721,11327,98374,81298,50810,15619,91930,6342,85546,36311,22887,48357,34841,82078,55852,48652,15211,92723,58836,85727,71654,13145,77612,93602,38677,90871,19314,35082,3668,79192,83396,96046,74913,18622,84086,21314,23646,7190,1353,64632,99713,80702,46751,69965,87230,40202,79936,86202,14692,47184,16850,13805,30403,7023,77364,44972,97006,9659,37684,75777,79416,85494,59440,47852,99214,47773,11717,18744,58757]],["events",[37007]],["@hathor/wallet-lib>isomorphic-ws",[30169]],["zod",[7552,33279,76601,98706,64084,24362,90523,95341,32564,91988,87319,76020,45167,95832,41168,47714,93584,12949,45039,51472,45292,28208,8761,3517,12058,44370,87073,45058,82848,50832,50974,39081,55662,5542,60765,92,74313,28195,13181,89917,20645,2519,66068,37005,62790,12297,513,25570,78520,52338,3424,57041,54003,75911,31637,67316,24290,40999,9587,80093,91114,52405,70485,8359,99874,56549,44725,48035,79299,72392,39633,62764,28262,45435,62373,73371,57048,70666,59737,53705,58424,33457,97776,96029,61749,1975,78617,94946,36904,62009,84757,61101,11790,77962,84143,19943,79218,30075,66185,37977,57047,68102,61607,94939,95530,82017,72702,84500,37678,22330,20562,25844,54045,43286,52763,26906,41490,55287,87413,91883,57929,90210,28672,75424,47858,4681,57111,83248,94008,82178,83795,20638,49958,66687,3698,3174,33471,47356,17661,78862]],["@hathor/wallet-lib>bitcore-lib",[70221,52978,62731,6213,66617,15558,65115,49845,56142,44371,23825,969,44499,33158,10555,87089,26303,49559,2832,91093,70566,69118,54878,93519,69807,48758,92202,99039,42109,96509,68237,61889,3544,13981,39368,78743,38072,91182,78495,3272,14093,64111,51990,36135,69912,92959,85549,85302,94367]],["@hathor/wallet-lib>bitcore-lib>elliptic>bn.js",[39404]],["@hathor/wallet-lib>lodash",[2543]],["assert",[94148,69597,3918,82299]],["assert>util",[40537,49032,81135]],["assert>util>is-arguments",[47244]],["assert>util>is-arguments>has-tostringtag",[49092]],["assert>object.assign>has-symbols",[41333,64039]],["assert>object.assign>call-bound",[36556]],["assert>call-bind>get-intrinsic",[70453]],["assert>object.assign>es-object-atoms",[79612]],["assert>call-bind>get-intrinsic>es-errors",[69383,41237,79290,79538,58068,69675,35345]],["assert>call-bind>get-intrinsic>math-intrinsics",[71514,58968,6188,68002,75880,70414,73093,94459]],["assert>util>which-typed-array>gopd",[75795,6549]],["assert>call-bind>es-define-property",[30655]],["assert>util>which-typed-array>get-proto",[93628,48648,71064]],["assert>util>which-typed-array>get-proto>dunder-proto",[7176]],["assert>call-bind>call-bind-apply-helpers",[73126,10076,13144,11002,47119,12205]],["assert>call-bind>get-intrinsic>function-bind",[66743,89353]],["assert>call-bind>get-intrinsic>hasown",[32338]],["assert>util>is-generator-function",[48184]],["assert>util>is-generator-function>safe-regex-test",[99721]],["assert>util>is-generator-function>safe-regex-test>is-regex",[14035]],["assert>util>which-typed-array",[25767]],["assert>util>which-typed-array>for-each",[82682]],["assert>util>which-typed-array>for-each>is-callable",[69600]],["assert>util>which-typed-array>available-typed-arrays",[39209]],["assert>util>which-typed-array>available-typed-arrays>possible-typed-array-names",[76578]],["assert>call-bind",[10487,38075]],["assert>call-bind>set-function-length",[96897]],["assert>is-nan>define-properties>define-data-property",[30041]],["assert>is-nan>define-properties>has-property-descriptors",[30592]],["assert>util>is-typed-array",[35680]],["assert>util>inherits",[56698]],["assert>object.assign",[11514,38403]],["assert>object.assign>object-keys",[1189,1093,28875]],["assert>object-is",[9394,89211,37653,36576]],["assert>is-nan>define-properties",[38452]],["assert>is-nan",[24133,13003,76642,92464]],["@hathor/wallet-lib>bitcore-lib>elliptic",[86729,1636,47011,894,36677,39188,30370,31298,60480,74011,57447,61200,28545,8650,46661,90220]],["@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert",[43349]],["@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-crypto-utils",[64367]],["@hathor/wallet-lib>bitcore-lib>elliptic>brorand",[15037]],["node-stdlib-browser>crypto-browserify",[91565]],["copy-webpack-plugin>serialize-javascript>randombytes",[53209]],["webpack-dev-server>express>safe-buffer",[92861]],["node-stdlib-browser>crypto-browserify>create-hash",[47108,20320]],["node-stdlib-browser>crypto-browserify>create-hash>md5.js",[88276]],["node-stdlib-browser>crypto-browserify>hash-base",[4729]],["node-stdlib-browser>stream-browserify",[88310]],["node-stdlib-browser>readable-stream",[45412,40345,80345,75896,65291,86048,25382,16708,2955,86238,55157,74610,63600,57758,28399]],["tailwindcss>postcss-selector-parser>util-deprecate",[94643]],["node-stdlib-browser>string_decoder",[83141]],["node-stdlib-browser>crypto-browserify>create-hash>ripemd160",[66011]],["node-stdlib-browser>crypto-browserify>pbkdf2>sha.js",[62802,27816,90392,63737,26710,24107,32827,82890]],["node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer",[15377]],["@lavamoat/webpack>json-stable-stringify>isarray",[64634]],["node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer>typed-array-buffer",[74372]],["node-stdlib-browser>crypto-browserify>create-hash>cipher-base",[56168]],["node-stdlib-browser>crypto-browserify>create-hmac",[83507,41800]],["node-stdlib-browser>crypto-browserify>browserify-sign",[55715,62951,20,35359,64589,74847]],["node-stdlib-browser>crypto-browserify>pbkdf2",[78396,43832,64196,2455,21352,93382]],["node-stdlib-browser>crypto-browserify>browserify-cipher",[30125]],["node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des",[84050,32438]],["node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des>des.js",[29560,87626,82808,82211,3389,65279]],["node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes",[1241,25799,530,52632,92884,46383,86975,55264,46843,63053,45122,3219,92356,50462,25892,50650,36171]],["node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes>buffer-xor",[30295]],["node-stdlib-browser>crypto-browserify>browserify-cipher>evp_bytestokey",[68078]],["node-stdlib-browser>crypto-browserify>diffie-hellman",[15380,4934,23241,14910]],["node-stdlib-browser>crypto-browserify>diffie-hellman>miller-rabin",[52244]],["node-stdlib-browser>crypto-browserify>public-encrypt>browserify-rsa",[67332]],["node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1",[78170,21137,36413,15579,24101]],["node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1>asn1.js",[87568,47363,9673,89220,47227,90993,22153,74598,22853,62010,58903,24669,70082,90735]],["node-stdlib-browser>crypto-browserify>create-ecdh",[61324]],["node-stdlib-browser>crypto-browserify>public-encrypt",[97168,28902,48206,52061,99247,77362]],["node-stdlib-browser>crypto-browserify>randomfill",[76983]],["@hathor/wallet-lib>bitcore-lib>elliptic>hash.js",[77952,67426,66166,46229,43917,66225,25333,2287,21911,57766,46784,28948]],["@hathor/wallet-lib>bitcore-lib>elliptic>hmac-drbg",[32723]],["@hathor/wallet-lib>bitcore-lib>bs58",[16763]],["@hathor/wallet-lib>bitcore-lib>bs58>base-x",[95364]],["@hathor/wallet-lib>bitcore-lib>bech32",[22343]],["@hathor/wallet-lib>bitcore-lib>buffer-compare",[25113]],["@hathor/wallet-lib>bitcore-lib>bip-schnorr",[82237,3024,26755,71041,53734,29899,13856]],["@hathor/wallet-lib>bitcore-lib>bip-schnorr>bigi",[83908,9251,19235,38523]],["@hathor/wallet-lib>bitcore-lib>bip-schnorr>ecurve",[48911,84109,37372,64555,91452]],["@hathor/wallet-lib>bitcore-lib>bip-schnorr>js-sha256",[71312]],["node-stdlib-browser>url",[88835]],["node-polyfill-webpack-plugin>punycode",[48379]],["webpack-dev-server>express>qs",[55373,98636,37720,74765,62642]],["webpack-dev-server>express>qs>side-channel",[920]],["webpack-dev-server>express>qs>side-channel>object-inspect",[58859]],["webpack-dev-server>express>qs>side-channel>side-channel-list",[14803]],["webpack-dev-server>express>qs>side-channel>side-channel-map",[80507]],["webpack-dev-server>express>qs>side-channel>side-channel-weakmap",[72271]],["@hathor/wallet-lib>axios",[86425]],["node-stdlib-browser>path-browserify",[57975]],["@hathor/wallet-lib>queue-microtask",[79596]],["@hathor/wallet-lib>crypto-js",[21396,19021,43240,6440,45503,80754,64725,84636,45471,63009,36308,81380,89557,45953,78056,51025,70019,39506,57165,82169,96939,6372,73797,38454,42073,54905,10482,52155,58124,70025,40955,7628,77193,96298,22696,43128]],["@hathor/wallet-lib>bitcore-mnemonic",[32362,9400,97653,55475,52992,13287,66760,29390,22928,3797,27890,41520]],["@hathor/wallet-lib>bitcore-mnemonic>unorm",[77063]],["node-stdlib-browser>browserify-zlib",[78559,5974]],["node-stdlib-browser>browserify-zlib>pako",[44442,58411,9805,23665,53269,14823,54674,71447,47293,21998,19681]],["@metamask/snaps-utils>@metamask/rpc-errors",[55717]],["@hathor/unleash-client",[31817,29522,32600,5947]],["@radix-ui/react-select",[70854]],["@radix-ui/react-select>@radix-ui/number",[56165]],["@radix-ui/react-toast>@radix-ui/react-collection",[16214]],["@radix-ui/react-select>@radix-ui/react-direction",[71427]],["@radix-ui/react-select>@radix-ui/react-popper",[5272]],["@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom",[34743]],["@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom",[18491]],["@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/core",[95361]],["@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/utils",[97193,86635]],["@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-arrow",[48771]],["@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-use-size",[31769]],["@radix-ui/react-select>@radix-ui/react-use-previous",[85357]],["@radix-ui/react-toast>@radix-ui/react-visually-hidden",[54644]],["react-router-dom>react-router",[61526]],["@radix-ui/react-toast",[22781]],["react-hook-form",[49785]],["@hookform/resolvers",[28792,76912]],["react-qr-code",[194,41853]],["react-qr-code>prop-types",[5556,2694,6925]],["react-qr-code>qr.js",[41537,46641,17790,19852,12835,10046,38759,30501,39341]]]);
;/*unenforceable*/;
LAVAMOAT['unenforceable'] = ([18950,42634]);
;/*ctxm*/;
LAVAMOAT['ctxm'] = ([]);
;/*kch*/;
LAVAMOAT['kch'] = ([792]);
;/*externals*/;
LAVAMOAT['externals'] = ({});
;/*options*/;
LAVAMOAT['options'] = ({"scuttleGlobalThis":{"enabled":false,"exceptions":["webpackChunk_hathor_web_wallet"]},"lockdown":{"errorTaming":"unsafe","stackFiltering":"verbose","overrideTaming":"severe","localeTaming":"unsafe"}});
;/*policy*/;
LAVAMOAT['policy'] = ({"resources":{"react":{"packages":{"node-stdlib-browser":true},"globals":{"reportError":true,"ErrorEvent":true,"dispatchEvent":true,"process":true,"console.error":true}},"node-stdlib-browser":{"globals":{"setTimeout":true,"clearTimeout":true}},"react-dom":{"packages":{"react":true,"node-stdlib-browser":true,"react-dom>scheduler":true},"globals":{"__REACT_DEVTOOLS_GLOBAL_HOOK__":true,"console.error":true,"event":true,"document":true,"addEventListener":true,"removeEventListener":true,"clipboardData":true,"ErrorEvent":true,"dispatchEvent":true,"AbortController":true,"reportError":true,"process":true,"setTimeout":true,"FormData":true,"clearTimeout":true,"queueMicrotask":true,"matchMedia":true}},"react-dom>scheduler":{"globals":{"process.env.NODE_ENV":true,"performance":true,"setTimeout":true,"clearTimeout":true,"setImmediate":true,"MessageChannel":true,"console.error":true}},"buffer":{"packages":{"buffer>ieee754":true,"buffer>base64-js":true},"globals":{"console":true}},"@hathor/snap-utils":{"packages":{"react":true},"globals":{"ethereum":true,"removeEventListener":true,"addEventListener":true,"dispatchEvent":true,"setTimeout":true,"clearTimeout":true,"Event":true,"process.env.SNAP_ORIGIN":true,"console":true}},"@radix-ui/react-dialog":{"packages":{"react":true,"@radix-ui/react-toast>@radix-ui/primitive":true,"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-context":true,"@radix-ui/react-dialog>@radix-ui/react-id":true,"@radix-ui/react-toast>@radix-ui/react-use-controllable-state":true,"@radix-ui/react-toast>@radix-ui/react-dismissable-layer":true,"@radix-ui/react-dialog>@radix-ui/react-focus-scope":true,"@radix-ui/react-toast>@radix-ui/react-portal":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-dialog>@radix-ui/react-focus-guards":true,"@radix-ui/react-slot":true,"@radix-ui/react-dialog>react-remove-scroll":true,"@radix-ui/react-dialog>aria-hidden":true,"@radix-ui/react-toast>@radix-ui/react-presence":true},"globals":{"document.getElementById":true,"console.error":true,"console.warn":true}},"@radix-ui/react-toast>@radix-ui/primitive":{"globals":{"document":true}},"@radix-ui/react-slot>@radix-ui/react-compose-refs":{"packages":{"react":true}},"@radix-ui/react-toast>@radix-ui/react-context":{"packages":{"react":true}},"@radix-ui/react-dialog>@radix-ui/react-id":{"packages":{"react":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true}},"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":{"packages":{"react":true},"globals":{"document":true}},"@radix-ui/react-toast>@radix-ui/react-use-controllable-state":{"packages":{"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"react":true,"@radix-ui/react-toast>@radix-ui/react-use-controllable-state>@radix-ui/react-use-effect-event":true},"globals":{"console.warn":true}},"@radix-ui/react-toast>@radix-ui/react-dismissable-layer":{"packages":{"@radix-ui/react-toast>@radix-ui/primitive":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"react":true,"@radix-ui/react-toast>@radix-ui/react-dismissable-layer>@radix-ui/react-use-escape-keydown":true},"globals":{"document":true,"setTimeout":true,"clearTimeout":true,"CustomEvent":true}},"@radix-ui/react-toast>@radix-ui/react-primitive":{"packages":{"@radix-ui/react-slot":true,"react":true,"react-dom":true}},"@radix-ui/react-slot":{"packages":{"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"react":true}},"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":{"packages":{"react":true}},"@radix-ui/react-toast>@radix-ui/react-dismissable-layer>@radix-ui/react-use-escape-keydown":{"packages":{"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"react":true},"globals":{"document":true}},"@radix-ui/react-dialog>@radix-ui/react-focus-scope":{"packages":{"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"react":true},"globals":{"document.activeElement":true,"document.body":true,"document.addEventListener":true,"document.removeEventListener":true,"document.createTreeWalker":true,"MutationObserver":true,"CustomEvent":true,"setTimeout":true,"NodeFilter.SHOW_ELEMENT":true,"NodeFilter.FILTER_SKIP":true,"NodeFilter.FILTER_ACCEPT":true,"getComputedStyle":true,"HTMLInputElement":true}},"@radix-ui/react-toast>@radix-ui/react-portal":{"packages":{"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"react":true,"react-dom":true},"globals":{"document.body":true}},"@radix-ui/react-toast>@radix-ui/react-presence":{"packages":{"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"react":true},"globals":{"CSS.escape":true,"getComputedStyle":true}},"@radix-ui/react-dialog>@radix-ui/react-focus-guards":{"packages":{"react":true},"globals":{"document.querySelectorAll":true,"document.body.insertAdjacentElement":true,"document.createElement":true}},"@radix-ui/react-dialog>aria-hidden":{"globals":{"document":true,"console.error":true,"HTMLElement":true}},"@radix-ui/react-dialog>react-remove-scroll":{"packages":{"react":true,"@radix-ui/react-dialog>aria-hidden>tslib":true,"@radix-ui/react-dialog>react-remove-scroll>use-callback-ref":true,"@radix-ui/react-dialog>react-remove-scroll>react-remove-scroll-bar":true,"@radix-ui/react-dialog>react-remove-scroll>use-sidecar":true,"@radix-ui/react-dialog>react-remove-scroll>react-style-singleton":true},"globals":{"document.addEventListener":true,"document.removeEventListener":true,"setTimeout":true,"ShadowRoot":true,"addEventListener":true,"removeEventListener":true,"Element":true,"getComputedStyle":true,"Node.DOCUMENT_FRAGMENT_NODE":true,"document.body":true}},"@radix-ui/react-dialog>aria-hidden>tslib":{"globals":{"Iterator":true,"AsyncIterator":true,"SuppressedError":true}},"@radix-ui/react-dialog>react-remove-scroll>react-remove-scroll-bar":{"packages":{"react":true,"@radix-ui/react-dialog>react-remove-scroll>react-style-singleton":true},"globals":{"getComputedStyle":true,"innerWidth":true,"document.body":true,"document.documentElement.clientWidth":true}},"@radix-ui/react-dialog>react-remove-scroll>use-sidecar":{"packages":{"@radix-ui/react-dialog>aria-hidden>tslib":true,"react":true}},"@radix-ui/react-dialog>react-remove-scroll>use-callback-ref":{"packages":{"react":true}},"@radix-ui/react-dialog>react-remove-scroll>react-style-singleton":{"packages":{"react":true,"@radix-ui/react-dialog>react-remove-scroll>react-style-singleton>get-nonce":true},"globals":{"document":true}},"@radix-ui/react-dialog>react-remove-scroll>react-style-singleton>get-nonce":{"globals":{"__webpack_nonce__":true}},"lucide-react":{"packages":{"react":true}},"class-variance-authority":{"packages":{"clsx":true}},"@hathor/wallet-lib":{"packages":{"events":true,"@hathor/wallet-lib>isomorphic-ws":true,"zod":true,"@hathor/wallet-lib>bitcore-lib":true,"@hathor/wallet-lib>axios":true,"buffer":true,"@hathor/wallet-lib>lodash":true,"node-stdlib-browser>path-browserify":true,"node-stdlib-browser>crypto-browserify":true,"@hathor/wallet-lib>queue-microtask":true,"@hathor/wallet-lib>crypto-js":true,"@hathor/wallet-lib>bitcore-mnemonic":true,"node-stdlib-browser>browserify-zlib":true,"assert":true},"globals":{"console":true,"clearTimeout":true,"setTimeout":true,"setInterval":true,"clearInterval":true,"Buffer.from":true,"Intl.NumberFormat":true,"Buffer.concat":true,"AbortController":true,"Buffer.alloc":true}},"events":{"globals":{"console":true}},"@hathor/wallet-lib>isomorphic-ws":{"globals":{"WebSocket":true,"MozWebSocket":true}},"zod":{"globals":{"navigator":true,"File":true,"atob":true,"btoa":true,"URL":true,"console.warn":true,"core":true,"locales":true,"iso":true,"coerce":true,"util":true,"regexes":true,"JSONSchema":true}},"@hathor/wallet-lib>bitcore-lib":{"packages":{"buffer":true,"@hathor/wallet-lib>lodash":true,"@hathor/wallet-lib>bitcore-lib>bs58":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"@hathor/wallet-lib>bitcore-lib>elliptic":true,"assert":true,"node-stdlib-browser>crypto-browserify":true,"@hathor/wallet-lib>bitcore-lib>bech32":true,"@hathor/wallet-lib>bitcore-lib>buffer-compare":true,"@hathor/wallet-lib>bitcore-lib>bip-schnorr":true,"assert>util>inherits":true,"node-stdlib-browser":true,"node-stdlib-browser>url":true},"globals":{"_bitcore":"write","Buffer":true,"console.error":true,"SEQUENCE_LOCKTIME_DISABLE_FLAG":true,"process.browser":true,"crypto":true,"msCrypto":true}},"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":{"packages":{"buffer":true},"globals":{"Buffer":true}},"@hathor/wallet-lib>lodash":{"globals":{"define":true,"clearTimeout":true,"setTimeout":true}},"assert":{"packages":{"node-stdlib-browser":true,"assert>call-bind":true,"assert>object-is":true,"assert>object.assign":true,"assert>util":true,"assert>is-nan":true},"globals":{"process.emitWarning":true,"console":true,"process.stderr":true}},"assert>util":{"packages":{"node-stdlib-browser":true,"assert>util>inherits":true,"assert>util>is-arguments":true,"assert>util>is-generator-function":true,"assert>util>which-typed-array":true,"assert>util>is-typed-array":true},"globals":{"process":true,"console.trace":true,"console.error":true,"console.log":true}},"assert>util>is-arguments":{"packages":{"assert>object.assign>call-bound":true,"assert>util>is-arguments>has-tostringtag":true}},"assert>util>is-arguments>has-tostringtag":{"packages":{"assert>object.assign>has-symbols":true}},"assert>object.assign>call-bound":{"packages":{"assert>call-bind>get-intrinsic":true,"assert>call-bind>call-bind-apply-helpers":true}},"assert>call-bind>get-intrinsic":{"packages":{"assert>call-bind>es-define-property":true,"assert>call-bind>call-bind-apply-helpers":true,"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>get-intrinsic>math-intrinsics":true,"assert>object.assign>has-symbols":true,"assert>util>which-typed-array>get-proto":true,"assert>object.assign>es-object-atoms":true,"assert>util>which-typed-array>gopd":true,"assert>call-bind>get-intrinsic>hasown":true,"assert>call-bind>get-intrinsic>function-bind":true},"globals":{"AggregateError":true,"Float16Array":true,"FinalizationRegistry":true,"WeakRef":true,"Atomics":true}},"assert>util>which-typed-array>get-proto":{"packages":{"assert>util>which-typed-array>get-proto>dunder-proto":true,"assert>object.assign>es-object-atoms":true}},"assert>util>which-typed-array>get-proto>dunder-proto":{"packages":{"assert>call-bind>call-bind-apply-helpers":true,"assert>util>which-typed-array>gopd":true}},"assert>call-bind>call-bind-apply-helpers":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>get-intrinsic>function-bind":true}},"assert>call-bind>get-intrinsic>hasown":{"packages":{"assert>call-bind>get-intrinsic>function-bind":true}},"assert>util>is-generator-function":{"packages":{"assert>object.assign>call-bound":true,"assert>util>which-typed-array>get-proto":true,"assert>util>is-arguments>has-tostringtag":true,"assert>util>is-generator-function>safe-regex-test":true}},"assert>util>is-generator-function>safe-regex-test":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>object.assign>call-bound":true,"assert>util>is-generator-function>safe-regex-test>is-regex":true}},"assert>util>is-generator-function>safe-regex-test>is-regex":{"packages":{"assert>util>is-arguments>has-tostringtag":true,"assert>object.assign>call-bound":true,"assert>call-bind>get-intrinsic>hasown":true,"assert>util>which-typed-array>gopd":true}},"assert>util>which-typed-array":{"packages":{"assert>call-bind":true,"assert>object.assign>call-bound":true,"assert>util>which-typed-array>gopd":true,"assert>util>which-typed-array>get-proto":true,"assert>util>is-arguments>has-tostringtag":true,"assert>util>which-typed-array>available-typed-arrays":true,"assert>util>which-typed-array>for-each":true}},"assert>util>which-typed-array>for-each":{"packages":{"assert>util>which-typed-array>for-each>is-callable":true}},"assert>util>which-typed-array>for-each>is-callable":{"globals":{"document":true}},"assert>util>which-typed-array>available-typed-arrays":{"packages":{"assert>util>which-typed-array>available-typed-arrays>possible-typed-array-names":true}},"assert>call-bind":{"packages":{"assert>call-bind>call-bind-apply-helpers":true,"assert>call-bind>es-define-property":true,"assert>call-bind>set-function-length":true,"assert>call-bind>get-intrinsic":true}},"assert>call-bind>set-function-length":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>get-intrinsic":true,"assert>util>which-typed-array>gopd":true,"assert>is-nan>define-properties>has-property-descriptors":true,"assert>is-nan>define-properties>define-data-property":true}},"assert>is-nan>define-properties>define-data-property":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>es-define-property":true,"assert>util>which-typed-array>gopd":true}},"assert>is-nan>define-properties>has-property-descriptors":{"packages":{"assert>call-bind>es-define-property":true}},"assert>util>is-typed-array":{"packages":{"assert>util>which-typed-array":true}},"assert>object.assign":{"packages":{"assert>object.assign>has-symbols":true,"assert>object.assign>object-keys":true,"assert>object.assign>es-object-atoms":true,"assert>object.assign>call-bound":true}},"assert>object-is":{"packages":{"assert>call-bind":true,"assert>is-nan>define-properties":true}},"assert>is-nan>define-properties":{"packages":{"assert>object.assign>object-keys":true,"assert>is-nan>define-properties>has-property-descriptors":true,"assert>is-nan>define-properties>define-data-property":true}},"assert>is-nan":{"packages":{"assert>call-bind":true,"assert>is-nan>define-properties":true}},"@hathor/wallet-lib>bitcore-lib>elliptic":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>brorand":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert":true,"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-crypto-utils":true,"assert>util>inherits":true,"@hathor/wallet-lib>bitcore-lib>elliptic>hash.js":true,"@hathor/wallet-lib>bitcore-lib>elliptic>hmac-drbg":true}},"@hathor/wallet-lib>bitcore-lib>elliptic>brorand":{"packages":{"node-stdlib-browser>crypto-browserify":true},"globals":{"crypto":true,"msCrypto":true}},"node-stdlib-browser>crypto-browserify":{"packages":{"node-stdlib-browser>crypto-browserify>browserify-sign":true,"copy-webpack-plugin>serialize-javascript>randombytes":true,"node-stdlib-browser>crypto-browserify>create-hash":true,"node-stdlib-browser>crypto-browserify>create-hmac":true,"node-stdlib-browser>crypto-browserify>pbkdf2":true,"node-stdlib-browser>crypto-browserify>browserify-cipher":true,"node-stdlib-browser>crypto-browserify>diffie-hellman":true,"node-stdlib-browser>crypto-browserify>create-ecdh":true,"node-stdlib-browser>crypto-browserify>public-encrypt":true,"node-stdlib-browser>crypto-browserify>randomfill":true}},"copy-webpack-plugin>serialize-javascript>randombytes":{"packages":{"node-stdlib-browser":true,"webpack-dev-server>express>safe-buffer":true},"globals":{"crypto":true,"msCrypto":true,"process.nextTick":true}},"webpack-dev-server>express>safe-buffer":{"packages":{"buffer":true}},"node-stdlib-browser>crypto-browserify>create-hash":{"packages":{"assert>util>inherits":true,"node-stdlib-browser>crypto-browserify>create-hash>cipher-base":true,"node-stdlib-browser>crypto-browserify>create-hash>md5.js":true,"node-stdlib-browser>crypto-browserify>create-hash>ripemd160":true,"node-stdlib-browser>crypto-browserify>pbkdf2>sha.js":true}},"node-stdlib-browser>crypto-browserify>create-hash>md5.js":{"packages":{"assert>util>inherits":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>hash-base":true}},"node-stdlib-browser>crypto-browserify>hash-base":{"packages":{"webpack-dev-server>express>safe-buffer":true,"assert>util>inherits":true,"node-stdlib-browser>stream-browserify":true}},"node-stdlib-browser>stream-browserify":{"packages":{"assert>util>inherits":true,"events":true,"node-stdlib-browser>readable-stream":true}},"node-stdlib-browser>readable-stream":{"packages":{"buffer":true,"assert>util>inherits":true,"events":true,"assert>util":true,"node-stdlib-browser":true,"node-stdlib-browser>string_decoder":true,"tailwindcss>postcss-selector-parser>util-deprecate":true},"globals":{"process.nextTick":true,"process.stdout":true,"process.stderr":true}},"tailwindcss>postcss-selector-parser>util-deprecate":{"globals":{"console.trace":true,"console.warn":true,"localStorage":true}},"node-stdlib-browser>string_decoder":{"packages":{"webpack-dev-server>express>safe-buffer":true}},"node-stdlib-browser>crypto-browserify>create-hash>ripemd160":{"packages":{"buffer":true,"assert>util>inherits":true,"node-stdlib-browser>crypto-browserify>hash-base":true}},"node-stdlib-browser>crypto-browserify>pbkdf2>sha.js":{"packages":{"assert>util>inherits":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer":true}},"node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer":{"packages":{"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer>typed-array-buffer":true,"@lavamoat/webpack>json-stable-stringify>isarray":true}},"node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer>typed-array-buffer":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>object.assign>call-bound":true,"assert>util>is-typed-array":true}},"node-stdlib-browser>crypto-browserify>create-hash>cipher-base":{"packages":{"webpack-dev-server>express>safe-buffer":true,"assert>util>inherits":true,"node-stdlib-browser>stream-browserify":true,"node-stdlib-browser>string_decoder":true}},"node-stdlib-browser>crypto-browserify>create-hmac":{"packages":{"node-stdlib-browser>crypto-browserify>create-hash":true,"assert>util>inherits":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>create-hash>cipher-base":true,"node-stdlib-browser>crypto-browserify>create-hash>ripemd160":true,"node-stdlib-browser>crypto-browserify>pbkdf2>sha.js":true}},"node-stdlib-browser>crypto-browserify>browserify-sign":{"packages":{"node-stdlib-browser>crypto-browserify>create-hash":true,"assert>util>inherits":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>readable-stream":true,"node-stdlib-browser>crypto-browserify>create-hmac":true,"@hathor/wallet-lib>bitcore-lib>elliptic":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"node-stdlib-browser>crypto-browserify>public-encrypt>browserify-rsa":true,"node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1":true}},"node-stdlib-browser>crypto-browserify>pbkdf2":{"packages":{"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser":true,"node-stdlib-browser>crypto-browserify>create-hash":true,"node-stdlib-browser>crypto-browserify>create-hash>ripemd160":true,"node-stdlib-browser>crypto-browserify>pbkdf2>sha.js":true,"node-stdlib-browser>crypto-browserify>pbkdf2>to-buffer":true},"globals":{"crypto":true,"process":true,"queueMicrotask":true,"setImmediate":true,"setTimeout":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher":{"packages":{"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>evp_bytestokey":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des":{"packages":{"node-stdlib-browser>crypto-browserify>create-hash>cipher-base":true,"assert>util>inherits":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des>des.js":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-des>des.js":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert":true,"assert>util>inherits":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes":{"packages":{"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>create-hash>cipher-base":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>evp_bytestokey":true,"assert>util>inherits":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes>buffer-xor":true,"buffer":true},"globals":{"Buffer.concat":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes>buffer-xor":{"packages":{"buffer":true},"globals":{"Buffer":true}},"node-stdlib-browser>crypto-browserify>browserify-cipher>evp_bytestokey":{"packages":{"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>create-hash>md5.js":true}},"node-stdlib-browser>crypto-browserify>diffie-hellman":{"packages":{"buffer":true,"copy-webpack-plugin>serialize-javascript>randombytes":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"node-stdlib-browser>crypto-browserify>diffie-hellman>miller-rabin":true},"globals":{"Buffer":true}},"node-stdlib-browser>crypto-browserify>diffie-hellman>miller-rabin":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>brorand":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true}},"node-stdlib-browser>crypto-browserify>public-encrypt>browserify-rsa":{"packages":{"copy-webpack-plugin>serialize-javascript>randombytes":true,"webpack-dev-server>express>safe-buffer":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true}},"node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1":{"packages":{"node-stdlib-browser>crypto-browserify>pbkdf2":true,"webpack-dev-server>express>safe-buffer":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>browserify-aes":true,"node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1>asn1.js":true,"node-stdlib-browser>crypto-browserify>browserify-cipher>evp_bytestokey":true}},"node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1>asn1.js":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"assert>util>inherits":true,"buffer":true,"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert":true}},"node-stdlib-browser>crypto-browserify>create-ecdh":{"packages":{"buffer":true,"@hathor/wallet-lib>bitcore-lib>elliptic":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true},"globals":{"Buffer":true}},"node-stdlib-browser>crypto-browserify>public-encrypt":{"packages":{"copy-webpack-plugin>serialize-javascript>randombytes":true,"node-stdlib-browser>crypto-browserify>create-hash":true,"webpack-dev-server>express>safe-buffer":true,"@hathor/wallet-lib>bitcore-lib>elliptic>bn.js":true,"node-stdlib-browser>crypto-browserify>public-encrypt>browserify-rsa":true,"node-stdlib-browser>crypto-browserify>public-encrypt>parse-asn1":true}},"node-stdlib-browser>crypto-browserify>randomfill":{"packages":{"copy-webpack-plugin>serialize-javascript>randombytes":true,"node-stdlib-browser":true,"webpack-dev-server>express>safe-buffer":true},"globals":{"crypto":true,"msCrypto":true,"process.browser":true,"process.nextTick":true}},"@hathor/wallet-lib>bitcore-lib>elliptic>hash.js":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert":true,"assert>util>inherits":true}},"@hathor/wallet-lib>bitcore-lib>elliptic>hmac-drbg":{"packages":{"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-assert":true,"@hathor/wallet-lib>bitcore-lib>elliptic>hash.js":true,"@hathor/wallet-lib>bitcore-lib>elliptic>minimalistic-crypto-utils":true}},"@hathor/wallet-lib>bitcore-lib>bs58":{"packages":{"@hathor/wallet-lib>bitcore-lib>bs58>base-x":true}},"@hathor/wallet-lib>bitcore-lib>bs58>base-x":{"packages":{"webpack-dev-server>express>safe-buffer":true}},"@hathor/wallet-lib>bitcore-lib>bip-schnorr":{"packages":{"webpack-dev-server>express>safe-buffer":true,"@hathor/wallet-lib>bitcore-lib>bip-schnorr>ecurve":true,"@hathor/wallet-lib>bitcore-lib>bip-schnorr>bigi":true,"copy-webpack-plugin>serialize-javascript>randombytes":true,"@hathor/wallet-lib>bitcore-lib>bip-schnorr>js-sha256":true}},"@hathor/wallet-lib>bitcore-lib>bip-schnorr>bigi":{"packages":{"buffer":true,"assert":true},"globals":{"Buffer":true}},"@hathor/wallet-lib>bitcore-lib>bip-schnorr>ecurve":{"packages":{"webpack-dev-server>express>safe-buffer":true,"@hathor/wallet-lib>bitcore-lib>bip-schnorr>bigi":true,"assert":true}},"@hathor/wallet-lib>bitcore-lib>bip-schnorr>js-sha256":{"packages":{"node-stdlib-browser":true},"globals":{"process":true,"define":true}},"node-stdlib-browser>url":{"packages":{"node-polyfill-webpack-plugin>punycode":true,"webpack-dev-server>express>qs":true}},"webpack-dev-server>express>qs":{"packages":{"webpack-dev-server>express>qs>side-channel":true}},"webpack-dev-server>express>qs>side-channel":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"webpack-dev-server>express>qs>side-channel>side-channel-map":true,"webpack-dev-server>express>qs>side-channel>side-channel-list":true,"webpack-dev-server>express>qs>side-channel>object-inspect":true,"webpack-dev-server>express>qs>side-channel>side-channel-weakmap":true}},"webpack-dev-server>express>qs>side-channel>object-inspect":{"globals":{"WeakRef":true,"HTMLElement":true}},"webpack-dev-server>express>qs>side-channel>side-channel-list":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"webpack-dev-server>express>qs>side-channel>object-inspect":true}},"webpack-dev-server>express>qs>side-channel>side-channel-map":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>get-intrinsic":true,"assert>object.assign>call-bound":true,"webpack-dev-server>express>qs>side-channel>object-inspect":true}},"webpack-dev-server>express>qs>side-channel>side-channel-weakmap":{"packages":{"assert>call-bind>get-intrinsic>es-errors":true,"assert>call-bind>get-intrinsic":true,"assert>object.assign>call-bound":true,"webpack-dev-server>express>qs>side-channel>side-channel-map":true,"webpack-dev-server>express>qs>side-channel>object-inspect":true}},"@hathor/wallet-lib>axios":{"packages":{"buffer":true,"node-stdlib-browser":true},"globals":{"FormData":true,"importScripts":true,"location.href":true,"setImmediate":true,"setTimeout":true,"queueMicrotask":true,"process":true,"Blob":true,"Buffer.from":true,"URLSearchParams":true,"document":true,"navigator":true,"WorkerGlobalScope":true,"clearTimeout":true,"btoa":true,"XMLHttpRequest":true,"AbortController":true,"ReadableStream":true,"fetch":true,"Request":true,"Response":true,"TextEncoder":true,"console.warn":true,"postMessage":true,"addEventListener":true}},"node-stdlib-browser>path-browserify":{"packages":{"node-stdlib-browser":true},"globals":{"process.cwd":true}},"@hathor/wallet-lib>queue-microtask":{"globals":{"queueMicrotask":true,"setTimeout":true}},"@hathor/wallet-lib>crypto-js":{"packages":{"node-stdlib-browser>crypto-browserify":true},"globals":{"define":true,"crypto":true,"msCrypto":true}},"@hathor/wallet-lib>bitcore-mnemonic":{"packages":{"buffer":true,"@hathor/wallet-lib>bitcore-lib":true,"@hathor/wallet-lib>bitcore-mnemonic>unorm":true,"node-stdlib-browser>crypto-browserify":true},"globals":{"Buffer.isBuffer":true,"Buffer.alloc":true,"Buffer.from":true}},"@hathor/wallet-lib>bitcore-mnemonic>unorm":{"globals":{"define":true}},"node-stdlib-browser>browserify-zlib":{"packages":{"buffer":true,"assert":true,"node-stdlib-browser":true,"assert>util":true,"node-stdlib-browser>stream-browserify":true,"node-stdlib-browser>browserify-zlib>pako":true},"globals":{"process.nextTick":true,"Buffer.alloc":true}},"@hathor/unleash-client":{"globals":{"URL":true,"fetch":true}},"@radix-ui/react-select":{"packages":{"@radix-ui/react-slot":true,"react":true,"react-dom":true,"@radix-ui/react-select>@radix-ui/number":true,"@radix-ui/react-toast>@radix-ui/primitive":true,"@radix-ui/react-toast>@radix-ui/react-collection":true,"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-context":true,"@radix-ui/react-select>@radix-ui/react-direction":true,"@radix-ui/react-toast>@radix-ui/react-dismissable-layer":true,"@radix-ui/react-dialog>@radix-ui/react-focus-guards":true,"@radix-ui/react-dialog>@radix-ui/react-focus-scope":true,"@radix-ui/react-dialog>@radix-ui/react-id":true,"@radix-ui/react-select>@radix-ui/react-popper":true,"@radix-ui/react-toast>@radix-ui/react-portal":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"@radix-ui/react-toast>@radix-ui/react-use-controllable-state":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"@radix-ui/react-select>@radix-ui/react-use-previous":true,"@radix-ui/react-toast>@radix-ui/react-visually-hidden":true,"@radix-ui/react-dialog>aria-hidden":true,"@radix-ui/react-dialog>react-remove-scroll":true},"globals":{"DocumentFragment":true,"document.activeElement":true,"document.removeEventListener":true,"document.addEventListener":true,"addEventListener":true,"removeEventListener":true,"innerWidth":true,"innerHeight":true,"getComputedStyle":true,"clearInterval":true,"setInterval":true,"HTMLSelectElement.prototype":true,"clearTimeout":true,"setTimeout":true,"requestAnimationFrame":true,"Event":true}},"@radix-ui/react-toast>@radix-ui/react-collection":{"packages":{"@radix-ui/react-toast>@radix-ui/react-context":true,"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-slot":true,"react":true},"globals":{"Node.DOCUMENT_POSITION_PRECEDING":true,"MutationObserver":true}},"@radix-ui/react-select>@radix-ui/react-direction":{"packages":{"react":true}},"@radix-ui/react-select>@radix-ui/react-popper":{"packages":{"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-context":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"react":true,"@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-arrow":true,"@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-use-size":true,"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom":true,"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom":true},"globals":{"getComputedStyle":true}},"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom":{"packages":{"react":true,"react-dom":true,"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom":true,"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/utils":true},"globals":{"document":true}},"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom":{"packages":{"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/utils":true,"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/core":true},"globals":{"getComputedStyle":true,"clearTimeout":true,"setTimeout":true,"IntersectionObserver":true,"ResizeObserver":true,"cancelAnimationFrame":true,"requestAnimationFrame":true}},"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/core":{"packages":{"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/utils":true}},"@radix-ui/react-select>@radix-ui/react-popper>@floating-ui/react-dom>@floating-ui/dom>@floating-ui/utils":{"globals":{"document":true,"Node":true,"Element":true,"HTMLElement":true,"ShadowRoot":true,"CSS":true}},"@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-arrow":{"packages":{"@radix-ui/react-toast>@radix-ui/react-primitive":true,"react":true}},"@radix-ui/react-select>@radix-ui/react-popper>@radix-ui/react-use-size":{"packages":{"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"react":true},"globals":{"ResizeObserver":true}},"@radix-ui/react-select>@radix-ui/react-use-previous":{"packages":{"react":true}},"@radix-ui/react-toast>@radix-ui/react-visually-hidden":{"packages":{"@radix-ui/react-toast>@radix-ui/react-primitive":true,"react":true}},"react-router-dom>react-router":{"packages":{"react":true},"globals":{"URL":true,"console":true,"document":true,"DOMException":true,"location.origin":true,"location.href":true,"__reactRouterHdrActive":true,"__reactRouterContext":true,"location.reload":true,"matchMedia":true,"origin":true,"navigator.connection.saveData":true,"clearTimeout":true,"setTimeout":true,"__reactRouterVersion":"write","__staticRouterHydrationData":true,"history.state":true,"history.replaceState":true,"scrollTo":true,"history.scrollRestoration":true,"scrollY":true,"addEventListener":true,"removeEventListener":true,"confirm":true,"Headers":true,"Response":true,"AbortController":true,"Request":true,"URLSearchParams":true,"FormData":true,"TextDecoder":true,"TransformStream":true,"TextEncoder":true,"ReadableStream":true,"fetch":true,"MutationObserver":true,"sessionStorage.getItem":true,"sessionStorage.setItem":true,"sessionStorage.removeItem":true,"IntersectionObserver":true}},"@radix-ui/react-toast":{"packages":{"@radix-ui/react-toast>@radix-ui/primitive":true,"@radix-ui/react-slot>@radix-ui/react-compose-refs":true,"@radix-ui/react-toast>@radix-ui/react-collection":true,"@radix-ui/react-toast>@radix-ui/react-context":true,"@radix-ui/react-toast>@radix-ui/react-dismissable-layer":true,"@radix-ui/react-toast>@radix-ui/react-portal":true,"@radix-ui/react-toast>@radix-ui/react-primitive":true,"@radix-ui/react-toast>@radix-ui/react-use-callback-ref":true,"@radix-ui/react-toast>@radix-ui/react-use-controllable-state":true,"@radix-ui/react-toast>@radix-ui/react-use-layout-effect":true,"@radix-ui/react-toast>@radix-ui/react-visually-hidden":true,"react":true,"react-dom":true,"@radix-ui/react-toast>@radix-ui/react-presence":true},"globals":{"console.error":true,"document.addEventListener":true,"document.removeEventListener":true,"document.activeElement":true,"document.createTreeWalker":true,"CustomEvent":true,"addEventListener":true,"removeEventListener":true,"clearTimeout":true,"setTimeout":true,"requestAnimationFrame":true,"cancelAnimationFrame":true,"NodeFilter.SHOW_ELEMENT":true,"NodeFilter.FILTER_SKIP":true,"NodeFilter.FILTER_ACCEPT":true}},"react-hook-form":{"packages":{"react":true},"globals":{"HTMLElement":true,"document":true,"FileList":true,"Blob":true,"FormData":true,"fetch":true,"clearTimeout":true,"setTimeout":true,"crypto":true,"performance":true}},"@hookform/resolvers":{"packages":{"react-hook-form":true,"zod":true}},"react-qr-code":{"packages":{"react":true,"react-qr-code>prop-types":true,"react-qr-code>qr.js":true}},"react-qr-code>prop-types":{"globals":{"process.env.NODE_ENV":true}},"$root$":{"globals":{"console":true}}}});
;/*ENUM*/;
LAVAMOAT['ENUM'] = ({
  "NAME_globalThis": "G",
  "NAME_scopeTerminator": "ST",
  "NAME_runtimeHandler": "RH",
  "RUNTIME_KEY": "_LM_"
}
);
;/*endowmentsToolkit*/;
;(()=>{
        const module = {exports: {}};
        const exports = module.exports;
          // @ts-check





module.exports = endowmentsToolkit

// Exports for testing
module.exports._test = { instrumentDynamicValueAtPath }


function endowmentsToolkit({
  createFunctionWrapper = defaultCreateFunctionWrapper,
  handleGlobalWrite = false,
  knownWritableFields = new Set(),
} = {}) {
  return {
    // public API
    getEndowmentsForConfig,
    copyWrappedGlobals,
    getBuiltinForConfig,
    createFunctionWrapper,
    // internals exposed for core
    // TODO: hide eventually?
    makeMinimalViewOfRef,
    copyValueAtPath,
    applyGetSetPropDescTransforms,
    applyEndowmentPropDescTransforms,
  }

  
  function getEndowmentsForConfig(
    sourceRef,
    packagePolicy,
    unwrapTo,
    unwrapFrom
  ) {
    if (!packagePolicy.globals) {
      return {}
    }
    // validate read access from packagePolicy
    
    const whitelistedReads = []
    
    const allowedWriteFields = new Set()
    
    const explicitlyBanned = []

    Object.entries(packagePolicy.globals).forEach(
      ([path, packagePolicyValue]) => {
        const pathParts = path.split('.')
        // disallow dunder proto in path
        const pathContainsDunderProto = pathParts.some(
          (pathPart) => pathPart === '__proto__'
        )
        if (pathContainsDunderProto) {
          throw new Error(
            `Lavamoat - "__proto__" disallowed when creating minimal view. saw "${path}"`
          )
        }
        // false means no access. It's necessary so that overrides can also be used to tighten the policy
        if (packagePolicyValue === false) {
          explicitlyBanned.push(path)
          return
        }
        // write access handled elsewhere
        if (packagePolicyValue === 'write') {
          if (!handleGlobalWrite) {
            return
          }
          if (pathParts.length > 1) {
            throw new Error(
              `LavaMoat - write access is only allowed at the top level, saw "${path}"`
            )
          }
          allowedWriteFields.add(path)
          whitelistedReads.push(path)
          return
        }
        if (packagePolicyValue !== true) {
          throw new Error(
            `LavaMoat - unrecognizable policy value (${typeof packagePolicyValue}) for path "${path}"`
          )
        }
        whitelistedReads.push(path)
      }
    )
    // sort by length to optimize further steps
    whitelistedReads.sort((a, b) => a.length - b.length)
    return makeMinimalViewOfRef(
      sourceRef,
      whitelistedReads,
      unwrapTo,
      unwrapFrom,
      explicitlyBanned,
      allowedWriteFields
    )
  }

  
  function makeMinimalViewOfRef(
    sourceRef,
    paths,
    unwrapTo,
    unwrapFrom,
    explicitlyBanned = [],
    allowedWriteFields = new Set()
  ) {
    
    const targetRef = {}
    paths.forEach((path) => {
      const pathParts = path.split('.')
      if (knownWritableFields.has(pathParts[0])) {
        if (allowedWriteFields.has(pathParts[0])) {
          makeWritableValueAtPath(pathParts[0], sourceRef, targetRef)
        } else {
          instrumentDynamicValueAtPath(pathParts, sourceRef, targetRef)
        }
      } else {
        copyValueAtPath(
          '',
          pathParts,
          explicitlyBanned,
          sourceRef,
          targetRef,
          unwrapTo,
          unwrapFrom
        )
      }
    })
    return targetRef
  }

  
  function getBuiltinForConfig(moduleNamespace, moduleId, policyBuiltin) {
    
    const builtinPaths = []

    
    const explicitlyBanned = []

    // Collect the same paths information as getEndowmentsForConfig to enable
    // matching behavior of policy between globals and builtins
    Object.entries(policyBuiltin).forEach(([packagePath, allowed]) => {
      const packagePathParts = packagePath.split('.')
      if (moduleId === packagePathParts[0]) {
        const packagePathWithoutPackage = packagePathParts.slice(1).join('.')
        if (allowed === true) {
          builtinPaths.push(packagePathWithoutPackage)
        } else if (allowed === false) {
          explicitlyBanned.push(packagePathWithoutPackage)
        }
      }
    })
    const moduleNamespaceView = makeMinimalViewOfRef(
      moduleNamespace,
      builtinPaths.sort(),
      undefined,
      undefined,
      explicitlyBanned
    )
    return moduleNamespaceView
  }

  
  function copyValueAtPath(
    visitedPath,
    pathParts,
    explicitlyBanned,
    sourceRef,
    targetRef,
    unwrapTo = sourceRef,
    unwrapFrom = targetRef
  ) {
    if (pathParts.length === 0) {
      throw new Error('unable to copy, must have pathParts, was empty')
    }
    const [nextPart, ...remainingParts] = pathParts
    const currentPath = extendPath(visitedPath, nextPart)
    // get the property from any depth in the property chain
    const { prop: sourcePropDesc } = getPropertyDescriptorDeep(
      sourceRef,
      nextPart
    )

    // if source missing the value to copy, just skip it
    if (isEmpty(sourcePropDesc)) {
      return
    }

    // if target already has a value, it must be extensible
    const targetPropDesc = Reflect.getOwnPropertyDescriptor(targetRef, nextPart)
    if (targetPropDesc) {
      // dont attempt to extend a getter or trigger a setter
      if (!('value' in targetPropDesc)) {
        throw new Error(
          `unable to copy on to targetRef, targetRef has a getter at "${currentPath}"`
        )
      }
      // value must be extensible (cant write properties onto it)
      const targetValue = targetPropDesc.value
      const valueType = typeof targetValue
      if (valueType !== 'object' && valueType !== 'function') {
        throw new Error(
          `unable to copy on to targetRef, targetRef value is not an obj or func at "${currentPath}"`
        )
      }
    }

    // if this is not the last path in the assignment, walk into the containing reference
    if (remainingParts.length > 0) {
      const { sourceValue, sourceWritable } = getSourceValue(sourcePropDesc)
      const nextSourceRef = sourceValue
      let nextTargetRef
      // check if value exists on target and does not need selective treatment
      if (targetPropDesc && !explicitlyBanned.includes(currentPath)) {
        // a value already exists, we should walk into it
        nextTargetRef = targetPropDesc.value
      } else {
        // its not populated so lets write to it
        // put an object to serve as a container
        const containerRef = {}
        const newPropDesc = {
          value: containerRef,
          writable: sourceWritable,
          enumerable: sourcePropDesc.enumerable,
          configurable: sourcePropDesc.configurable,
        }
        Reflect.defineProperty(targetRef, nextPart, newPropDesc)
        // the newly created container will be the next target
        nextTargetRef = containerRef
      }
      copyValueAtPath(
        currentPath,
        remainingParts,
        explicitlyBanned,
        nextSourceRef,
        nextTargetRef
      )
      return
    }

    // If conflicting rules exist, opt for the negative one. This should never happen
    if (explicitlyBanned.includes(currentPath)) {
      console.warn(`LavaMoat - conflicting rules exist for "${currentPath}"`)
      return
    }

    // this is the last part of the path, the value we're trying to actually copy
    // if has getter/setter - apply this-value unwrapping
    if (!('value' in sourcePropDesc)) {
      // wrapper setter/getter with correct receiver
      const wrapperPropDesc = applyGetSetPropDescTransforms(
        sourcePropDesc,
        unwrapFrom,
        unwrapTo
      )
      Reflect.defineProperty(targetRef, nextPart, wrapperPropDesc)
      return
    }

    // need to determine the value type in order to copy it with
    // this-value unwrapping support
    const { sourceValue, sourceWritable } = getSourceValue(sourcePropDesc)

    // not a function - copy as is
    if (typeof sourceValue !== 'function') {
      Reflect.defineProperty(targetRef, nextPart, sourcePropDesc)
      return
    }
    // otherwise add workaround for functions to swap back to the sourceal "this" reference
    
    const unwrapTest = (thisValue) => thisValue === unwrapFrom
    const newValue = createFunctionWrapper(sourceValue, unwrapTest, unwrapTo)
    const newPropDesc = {
      value: newValue,
      writable: sourceWritable,
      enumerable: sourcePropDesc.enumerable,
      configurable: sourcePropDesc.configurable,
    }
    Reflect.defineProperty(targetRef, nextPart, newPropDesc)

    
    function getSourceValue(sourcePropDesc) {
      // determine the source value, this coerces getters to values
      // im deeply sorry, respecting getters was complicated and
      // my brain is not very good
      let sourceValue, sourceWritable
      if ('value' in sourcePropDesc) {
        sourceValue = sourcePropDesc.value
        sourceWritable = sourcePropDesc.writable
      } else if ('get' in sourcePropDesc && sourcePropDesc.get) {
        sourceValue = sourcePropDesc.get.call(unwrapTo)
        sourceWritable = 'set' in sourcePropDesc
      } else {
        throw new Error(
          'getEndowmentsForConfig - property descriptor missing a getter'
        )
      }
      return { sourceValue, sourceWritable }
    }
  }

  
  function applyEndowmentPropDescTransforms(
    propDesc,
    unwrapFromCompartmentGlobalThis,
    unwrapToGlobalThis
  ) {
    let newPropDesc = propDesc
    newPropDesc = applyFunctionPropDescTransform(
      newPropDesc,
      unwrapFromCompartmentGlobalThis,
      unwrapToGlobalThis
    )
    newPropDesc = applyGetSetPropDescTransforms(
      newPropDesc,
      unwrapFromCompartmentGlobalThis,
      unwrapToGlobalThis
    )
    return newPropDesc
  }

  
  function applyGetSetPropDescTransforms(
    sourcePropDesc,
    unwrapFromGlobalThis,
    unwrapToGlobalThis
  ) {
    const wrappedPropDesc = { ...sourcePropDesc }
    if (sourcePropDesc.get) {
      wrappedPropDesc.get = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const receiver = this
        // replace the "receiver" value if it points to fake parent
        const receiverRef =
          receiver === unwrapFromGlobalThis ? unwrapToGlobalThis : receiver
        // sometimes getters replace themselves with static properties, as seen wih the FireFox runtime
        const result = Reflect.apply(
           (
            sourcePropDesc.get
          ),
          receiverRef,
          []
        )
        if (typeof result === 'function') {
          // functions must be wrapped to ensure a good this-value.
          // lockdown causes some propDescs to go to value -> getter,
          // eg "Function.prototype.bind". we need to wrap getter results
          // as well in order to ensure they have their this-value wrapped correctly
          // if this ends up being problematic we can maybe take advantage of lockdown's
          // "getter.originalValue" property being available
          return createFunctionWrapper(
            result,
            
            (thisValue) => thisValue === unwrapFromGlobalThis,
            unwrapToGlobalThis
          )
        } else {
          return result
        }
      }
    }
    if (sourcePropDesc.set) {
      wrappedPropDesc.set = function (value) {
        // replace the "receiver" value if it points to fake parent
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const receiver = this
        const receiverRef =
          receiver === unwrapFromGlobalThis ? unwrapToGlobalThis : receiver
        return Reflect.apply(
           (sourcePropDesc.set),
          receiverRef,
          [value]
        )
      }
    }
    return wrappedPropDesc
  }

  
  function applyFunctionPropDescTransform(
    propDesc,
    unwrapFromCompartmentGlobalThis,
    unwrapToGlobalThis
  ) {
    if (!('value' in propDesc && typeof propDesc.value === 'function')) {
      return propDesc
    }
    
    const unwrapTest = (thisValue) => {
      // unwrap function calls this-value to unwrapToGlobalThis when:
      // this value is globalThis ex. globalThis.abc()
      // scope proxy leak workaround ex. abc()
      return thisValue === unwrapFromCompartmentGlobalThis
    }
    const newFn = createFunctionWrapper(
      propDesc.value,
      unwrapTest,
      unwrapToGlobalThis
    )
    return { ...propDesc, value: newFn }
  }

  
  function getPropertyDescriptorDeep(target, key) {
    
    let receiver = target
    // eslint-disable-next-line no-constant-condition
    while (true) {
      // abort if this is the end of the prototype chain.
      if (!receiver) {
        return { prop: null, receiver: null }
      }
      // support lookup on objects and primitives
      const typeofReceiver = typeof receiver
      if (typeofReceiver === 'object' || typeofReceiver === 'function') {
        const prop = Reflect.getOwnPropertyDescriptor(receiver, key)
        if (prop) {
          return { receiver, prop }
        }
        // try next in the prototype chain
        receiver = Reflect.getPrototypeOf(receiver)
      } else {
        // prototype lookup for primitives
        // eslint-disable-next-line no-proto
        receiver =  (receiver).__proto__
      }
    }
  }

  
  function copyWrappedGlobals(
    globalRef,
    target,
    globalThisRefs = ['globalThis']
  ) {
    // find the relevant endowment sources
    const globalProtoChain = getPrototypeChain(globalRef)
    // the index for the common prototypal ancestor, Object.prototype
    // this should always be the last index, but we check just in case
    let commonPrototypeIndex = globalProtoChain.findIndex(
      (globalProtoChainEntry) => globalProtoChainEntry === Object.prototype
    )
    // "Why would a global have no reference in prototype chain that matches Object.prototype?" you might ask.
    // It's when the global is partially from a different Realm. And that's possible in extension contentscript in FireFox
    const noSharedPrototype = commonPrototypeIndex === -1
    if (noSharedPrototype) {
      // take the entire prototype chain
      commonPrototypeIndex = globalProtoChain.length
    }
    // we will copy endowments from all entries in the prototype chain, excluding Object.prototype
    const endowmentSources = globalProtoChain.slice(0, commonPrototypeIndex)

    // call all getters, in case of behavior change (such as with FireFox lazy getters)
    // call on contents of endowmentsSources directly instead of in new array instances. If there is a lazy getter it only changes the original prop desc.
    endowmentSources.forEach((source) => {
      const descriptors = Object.getOwnPropertyDescriptors(source)
      Object.values(descriptors).forEach((desc) => {
        if ('get' in desc && desc.get) {
          try {
            // calling getters can potentially throw (e.g. localStorage inside a sandboxed iframe)
            Reflect.apply(desc.get, globalRef, [])
          } catch {}
        }
      })
    })

    const endowmentSourceDescriptors = endowmentSources.map(
      (globalProtoChainEntry, index) => {
        const candidateDescriptors = Object.getOwnPropertyDescriptors(
          globalProtoChainEntry
        )
        if (noSharedPrototype && index === endowmentSources.length - 1) {
          // if there is no shared Object.prototype, the last entry in the endowmentSources
          // might be an Object.prototype from another realm. In that case we want to skip overriding Object.prototype keys
          const filteredDescriptors = Object.fromEntries(
            Object.entries(candidateDescriptors).filter(
              ([key]) => !(key in Object.prototype)
            )
          )
          return filteredDescriptors
        }
        return candidateDescriptors
      }
    )
    // flatten propDesc collections with precedence for globalThis-end of the prototype chain
    const endowmentDescriptorsFlat = Object.assign(
      Object.create(null),
      ...endowmentSourceDescriptors.reverse()
    )
    // expose all own properties of globalRef, including non-enumerable
    Object.entries(endowmentDescriptorsFlat)
      // ignore properties already defined on compartment global
      .filter(([key]) => !(key in target))
      // ignore circular globalThis refs
      .filter(([key]) => !globalThisRefs.includes(key))
      // define property on compartment global
      .forEach(([key, desc]) => {
        // unwrap functions, setters/getters & apply scope proxy workaround
        const wrappedPropDesc = applyEndowmentPropDescTransforms(
          desc,
          target,
          globalRef
        )
        Reflect.defineProperty(target, key, wrappedPropDesc)
      })
    // global circular references otherwise added by prepareCompartmentGlobalFromConfig
    // Add all circular refs to root package compartment globalThis
    for (const ref of globalThisRefs) {
      if (ref in target) {
        continue
      }
      target[ref] = target
    }
    return target
  }
}

function getPrototypeChain(value) {
  const protoChain = []
  let current = value
  while (
    current &&
    (typeof current === 'object' || typeof current === 'function')
  ) {
    protoChain.push(current)
    current = Reflect.getPrototypeOf(current)
  }
  return protoChain
}


function extendPath(visited, next) {
  // FIXME: second part of this conditional should be unnecessary
  if (!visited || visited.length === 0) {
    return next
  }
  return `${visited}.${next}`
}


function isEmpty(value) {
  return !value
}


function makeWritableValueAtPath(key, sourceRef, targetRef) {
  const enumerable = Reflect.getOwnPropertyDescriptor(
    sourceRef,
    key
  )?.enumerable
  Reflect.defineProperty(targetRef, key, {
    configurable: false,
    enumerable,
    set(newValue) {
      sourceRef[key] = newValue
    },
    get() {
      return sourceRef[key]
    },
  })
}


function instrumentDynamicValueAtPath(pathParts, sourceRef, targetRef) {
  const enumerable = Reflect.getOwnPropertyDescriptor(
    sourceRef,
    pathParts[0]
  )?.enumerable
  const dynamicGetterDesc = {
    get: () => {
      const dynamicValue = sourceRef[pathParts[0]]
      let leaf = dynamicValue,
        parent = sourceRef

      for (let i = 1; i < pathParts.length; i++) {
        parent = leaf
        leaf = leaf[pathParts[i]]
      }
      if (typeof leaf === 'function') {
        leaf = leaf.bind(parent) // TODO: consider the risks, should not differ from unwrapping
      }
      return leaf
    },
    writeable: false,
    enumerable, // Initial value will have to suffice. Change will not propagate dynamically.
    configurable: false,
  }
  let currentTarget = targetRef
  let currentPath = ''
  for (let depth = 0; depth < pathParts.length - 1; depth++) {
    currentPath = extendPath(currentPath, pathParts[depth])
    const nextPart = pathParts[depth]
    if (Reflect.getOwnPropertyDescriptor(currentTarget, nextPart)?.get) {
      // We could silently ignore this, but it could introduce a false sense of security in the policy file
      throw Error(
        `LavaMoat - "${pathParts[0]}" is writeable elsewhere and both "${currentPath}" and "${pathParts.join('.')}" are allowed for one package. One of these entries is redundant.`
      )
    }
    if (typeof currentTarget[nextPart] !== 'object') {
      currentTarget[nextPart] = {}
    }
    currentTarget = currentTarget[nextPart]
  }

  const lastPart = pathParts[pathParts.length - 1]
  Reflect.defineProperty(currentTarget, lastPart, dynamicGetterDesc)
}


function defaultCreateFunctionWrapper(sourceValue, unwrapTest, unwrapTo) {
  
  const newValue = function (...args) {
    if (new.target) {
      // handle constructor calls
      return Reflect.construct(sourceValue, args, new.target)
    } else {
      // handle function calls
      // unwrap to target value if this value is the source package compartment's globalThis
      const thisRef = unwrapTest(this) ? unwrapTo : this
      return Reflect.apply(sourceValue, thisRef, args)
    }
  }
  Object.defineProperties(
    newValue,
    Object.getOwnPropertyDescriptors(sourceValue)
  )
  // Global functions can have static fields on a prototype. eg. Uint8Array.from
  if (
    Reflect.getPrototypeOf(newValue) !== Reflect.getPrototypeOf(sourceValue)
  ) {
    Object.setPrototypeOf(newValue, Reflect.getPrototypeOf(sourceValue))
  }
  return newValue
}











        ;
        LAVAMOAT['endowmentsToolkit'] = module.exports;
      })();
;/*repairs*/;
;(()=>{
        const module = {exports: {}};
        const exports = module.exports;
          const { defineProperty } = Object
const { call } = Function.prototype

const messageToGlobalMap = new WeakMap()

const theRealGlobalThis = globalThis
// TODO: enabe after further testing:
// const realms = new Map()
// realms.set(globalThis.top || {}, 'top')
// realms.set(globalThis.parent || {}, 'parent')
// realms.set(globalThis.opener || {}, 'opener')

const mep = MessageEvent.prototype
// eslint-disable-next-line no-undef
const lastResortGlobal = new Compartment().globalThis

const original = Object.getOwnPropertyDescriptor(mep, 'source')
if (original && original.get) {
  const sourceGetter = call.bind(original.get)

  defineProperty(mep, 'source', {
    ...original,
    get() {
      const w = sourceGetter(this)
      // How the hell would globalThis !== globalThis.window? Ask FF contentscripts
      if (w === theRealGlobalThis || w === theRealGlobalThis.window) {
        return messageToGlobalMap.get(this) || lastResortGlobal
        // } else if (w && typeof w === 'object' && realms.has(w)) {
        //   return messageToGlobalMap.get(this)[realms.get(w)] || lastResortGlobal
      } else {
        return w
      }
    },
    // left configurable because replacing it with original is impossible after and we
    // want to allow further wrapping (eg by Snow)
  })
}


exports.MessageEvent = (
  endowments,
  theRealGlobalThis,
  packageCompartmentGlobal
) => {
  const originalConstructor = endowments.MessageEvent
  if (!originalConstructor) {
    return
  }

  
  endowments.MessageEvent = function MessageEvent(type, eventInitDict) {
    const nestedResult = new originalConstructor(type, eventInitDict)
    messageToGlobalMap.set(nestedResult, packageCompartmentGlobal)
    return nestedResult
  }
  endowments.MessageEvent.prototype = originalConstructor.prototype
  // WARNING: fidelity breaks down at MessageEvent.prototype.constructor,
  // which runs the original constructor and does not pin the resulting object
  // to a matching global in the WeakMap
}

exports.addEventListener = (
  endowments,
  theRealGlobalThis,
  packageCompartmentGlobal
) => {
  const originalListener = endowments.addEventListener
  if (!originalListener) {
    return
  }
  
  endowments.addEventListener = (type, listener, options) => {
    if (type === 'message') {
      
      const wrappedListener = (event) => {
        messageToGlobalMap.set(event, packageCompartmentGlobal)
        return listener.call(packageCompartmentGlobal, event)
      }
      return originalListener.call(
        theRealGlobalThis,
        type,
        wrappedListener,
        options
      )
    } else {
      // calling it on actual global will work even if it was wrapped for endowments
      return originalListener.call(
        packageCompartmentGlobal,
        type,
        listener,
        options
      )
    }
  }
}
;
;if ('event' in globalThis) {
  // @ts-ignore
  globalThis.event = undefined
  // Yes, that's the whole repair.
  // https://dev.to/naugtur/sometimes-the-best-thing-to-do-is-an-explicit-nothing-2i71
}
;
;const { getOwnPropertyNames } = Object


function getPrototypeChain(value) {
  const protoChain = []
  let current = value
  while (
    current &&
    (typeof current === 'object' || typeof current === 'function')
  ) {
    protoChain.push(current)
    current = Reflect.getPrototypeOf(current)
  }
  return protoChain
}

function elevateSecretPrototype(globalRef) {
  if (
    'window' in globalRef &&
    typeof globalRef.window === 'object' &&
    globalRef !== globalRef.window
  ) {
    const win = globalRef.window
    const windowProtoChain = getPrototypeChain(win)
    const globalProtoChain = getPrototypeChain(globalRef)
    windowProtoChain.pop() // remove Object.prototype
    // consider all properties on the prototype chain of window
    // that are defined on window, but not on globalThis
    const considerKeys = windowProtoChain.flatMap((proto) =>
      getOwnPropertyNames(proto)
    )

    const globalKeys = new Set(
      globalProtoChain.flatMap((proto) => getOwnPropertyNames(proto))
    )

    for (const key of considerKeys) {
      // this condition looks self-contradictory, but it's actually explicitly testing for fields that are reachable on globalRef by explicit lookup but cannot be discovered as own properties on the prototype chain items.
      if (
        !globalKeys.has(key) &&
        key in globalThis &&
        typeof win[key] !== 'undefined'
      ) {
        try {
          // Make a property that exists on the hidden prototype chain an own property of globalThis so that the regular logic of copying globals can find it.
          // The try-catch exists to avoid errors if a property is a getter-setter pair that we didn't know existed.
          // eslint-disable-next-line no-self-assign
          globalRef[key] = globalRef[key]
        } catch (e) {}
      }
    }
  }
  return globalRef
}

elevateSecretPrototype(globalThis)

        ;
        LAVAMOAT['repairs'] = module.exports;
      })();
;/*runtime*/;
;(()=>{
        const module = {exports: {}};
        const exports = module.exports;
          /// <reference path="./lavamoat.d.ts" />





const { repairIntrinsics } = globalThis

const warn = typeof console === 'object' ? console.warn : () => {}

// Avoid running any wrapped code or using compartment if lockdown was not called.
// This is for when the bundle ends up running despite SES being missing.
// It was previously useful for sub-compilations running an incomplete bundle as part of the build, but currently that is being skipped. We might go back to it for the sake of build time security if it's deemed worthwihile in absence of lockdown.
const LOCKDOWN_ON = typeof repairIntrinsics !== 'undefined'
if (LOCKDOWN_ON) {
  repairIntrinsics(LAVAMOAT.options.lockdown)

  LOCKDOWN_SHIMS.forEach((shim) => {
    shim()
  })

  hardenIntrinsics()
} else {
  warn(
    'LavaMoatPlugin: runtime execution started without SES present, switching to no-op.'
  )
}

const {
  keys,
  create,
  freeze,
  assign,
  defineProperty,
  defineProperties,
  getOwnPropertyDescriptors,
  fromEntries,
  entries,
  values,
} = Object

const { Proxy, Math, Date } = globalThis

// harden appears on globalThis only after lockdown is called
const { harden } = globalThis

const knownWritableFields = new Set()

values(LAVAMOAT.policy.resources).forEach((resource) => {
  if (resource.globals && typeof resource.globals === 'object') {
    entries(resource.globals).forEach(([key, value]) => {
      if (value === 'write') {
        knownWritableFields.add(key)
      }
    })
  }
})

const {
  getEndowmentsForConfig,
  copyWrappedGlobals,
  getBuiltinForConfig,
} = LAVAMOAT.endowmentsToolkit({
  handleGlobalWrite: true,
  knownWritableFields,
})

// These must match assumptions in the wrapper.js
// sharedKeys are included in the runtime

const { NAME_globalThis, NAME_scopeTerminator, NAME_runtimeHandler } =
  LAVAMOAT.ENUM

// strictScopeTerminator from SES is not strict enough - `has` would only return true for globals
// and here we want to prevent reaching into the scope where local variables from bundle runtime are available.
const stricterScopeTerminator = freeze(
  new Proxy(
    freeze(create(null)),
    freeze({
      // TODO: emulate a reference error in a getter.
      has: freeze(() => true),
    })
  )
)


const enforcePolicy = (specifier, referrerResourceId, wrappedRequire) => {
  if (typeof specifier === 'undefined') {
    throw Error(`Requested specifier is undefined`)
  }
  // skip enforcing what we determined at build time we cannot
  if (
    LAVAMOAT.unenforceable.includes(specifier) ||
    // implicitly allow all for root
    referrerResourceId === LAVAMOAT.root
  ) {
    return wrappedRequire()
  }

  const referrerPolicy = LAVAMOAT.policy.resources[referrerResourceId] || {}
  if (LAVAMOAT.externals[specifier]) {
    const externalName = LAVAMOAT.externals[specifier]
    if (referrerPolicy.builtin) {
      if (referrerPolicy.builtin[externalName]) {
        return wrappedRequire()
      }
      if (
        externalName &&
        !externalName.includes('.') &&
        keys(referrerPolicy.builtin).some((key) =>
          key.startsWith(`${externalName}.`)
        )
      ) {
        // create minimal selection if it's a builtin and not allowed as a whole, but with subpaths
        return getBuiltinForConfig(
          wrappedRequire(),
          externalName,
          referrerPolicy.builtin
        )
      }
    } 
    if (referrerPolicy.packages) {
      // if an external was automatically generate by webpack and is not recognized as builtin, but allowed as a package, we still need to pass it in.
      const requestedResourceId = findResourceId(externalName)
      if (requestedResourceId && referrerPolicy.packages[requestedResourceId]) {
        return wrappedRequire()
      }
    }
  }
  const requestedResourceId = findResourceId(specifier)
  if (!requestedResourceId) {
    if (LAVAMOAT.ctxm.includes(specifier)) {
      throw Error(
        `'${referrerResourceId}' is trying to load a module dynamically from a dependency it has not been allowed using the following Webpack Context Module: '${specifier}'`
      )
    }
    throw Error(
      `Requested specifier '${specifier}' is not allowed as a builtin and is not a known dependency of '${referrerResourceId}'; regenerate policy or add it to policy-override.json.`
    )
  }
  // allow imports internal to the package
  if (requestedResourceId === referrerResourceId) {
    return wrappedRequire()
  }
  if (referrerPolicy.packages?.[requestedResourceId]) {
    return wrappedRequire()
  }

  // This error message does not refer to specifier directly so it won't be confusing for a ContextModule either.
  throw Error(
    `Policy does not allow importing ${requestedResourceId} from ${referrerResourceId}`
  )
}

const theRealGlobalThis = globalThis

let rootCompartmentGlobalThis
const globalAliases = ['window', 'self', 'global', 'globalThis', 'frames']

const repairsAvailable = keys(LAVAMOAT.repairs || {})


const installGlobalsForPolicy = (resourceId, packageCompartmentGlobal) => {
  if (resourceId === LAVAMOAT.root) {
    rootCompartmentGlobalThis = packageCompartmentGlobal
    copyWrappedGlobals(
      theRealGlobalThis,
      rootCompartmentGlobalThis,
      globalAliases
    )
    LAVAMOAT?.scuttling?.scuttle(
      theRealGlobalThis,
      LAVAMOAT.options?.scuttleGlobalThis
    )
  } else {
    const packagePolicy = LAVAMOAT.policy.resources[resourceId] || {}
    const endowments = getEndowmentsForConfig(
      rootCompartmentGlobalThis,
      packagePolicy,
      globalThis,
      packageCompartmentGlobal
    )
    // Applies custom repairs to the endowments known to be used in the policy
    // Premature optimization opportunity: choose to iterate repairs or endowments depending on which is shorter
    if (
      repairsAvailable.length > 0 &&
      packagePolicy.globals &&
      keys(packagePolicy.globals).length > 0
    ) {
      repairsAvailable.forEach((repairName) => {
        if (endowments[repairName]) {
          const repair = LAVAMOAT.repairs[repairName]
          if (repair) {
            repair(endowments, theRealGlobalThis, packageCompartmentGlobal)
          }
        }
      })
    }

    defineProperties(packageCompartmentGlobal, {
      ...getOwnPropertyDescriptors(endowments),
      // preserve the correct global aliases even if endowments define them differently
      ...fromEntries(
        globalAliases.map((alias) => [
          alias,
          { value: packageCompartmentGlobal },
        ])
      ),
    })

    if (LAVAMOAT.debug) {
      LAVAMOAT.debug.debugProxy(
        packageCompartmentGlobal,
        rootCompartmentGlobalThis,
        resourceId
      )
    }
  }
}

const compartmentMap = new Map()

const findResourceId = (moduleId) => {
  const found = LAVAMOAT.idmap.find(([, moduleIds]) =>
    moduleIds.includes(moduleId)
  )
  if (found) {
    return found[0]
  }
}






const wrapRequireWithPolicy = (__webpack_require__, referrerResourceId) =>
  
  function (specifier, ...rest) {
    // not collapsing to string if it's a production bundle optimized down to numbers
    if (typeof specifier !== 'number') {
      specifier = `${specifier}`
    }
    const requireThat = __webpack_require__.bind(this, specifier, ...rest)
    return enforcePolicy(specifier, referrerResourceId, requireThat)
  }


const lavamoatRuntimeWrapper = (resourceId, runtimeKit) => {
  if (!LOCKDOWN_ON) {
    // Scope Terminator not being present in the output causes the wrapper closure to run a no-op instaed of the module body
    return create(null)
  }

  if (!compartmentMap.has(resourceId)) {
    // Endow original Math and Date, because SES tames them and we don't need that
    const c = new Compartment({ Math, Date })
    installGlobalsForPolicy(resourceId, c.globalThis)
    compartmentMap.set(resourceId, c)
  }

  const overrides = create(null)

  // modules may reference `require` dynamically, but that's something we don't want to allow
  const { __webpack_require__ } = runtimeKit
  let { module } = runtimeKit

  if (__webpack_require__) {
    // wrap webpack runtime for policy check and hardening
    const policyRequire = wrapRequireWithPolicy(__webpack_require__, resourceId)

    
    policyRequire.e = (chunkId) => {
      // Chunk resolution at runtime may be a lookup table or a string concatenation. In the latter case it can be fooled into loading any file from under publicPath. That's why we only want to accept known chunks.
      if (!LAVAMOAT.kch.includes(chunkId)) {
        throw Error(
          `Attempt to load a chunk that was not known at compile time: ${chunkId} from ${resourceId}`
        )
      }
      return __webpack_require__.e(chunkId)
    }
    // TODO: It's possible most of the work here could be done once instead of for each wrapping

    // Webpack has a few one-letter functions in the runtime and built-in plugins that add more runtime functions. We might need to support them eventually.
    // It's a case-by-case basis decision.
    // TODO: print a warning for other functions on the __webpack_require__ namespace that we're not supporting.
    //   It's probably best served at build time though - with runtimeRequirements or looking at the items in webpack runtime when adding lavamoat runtime.
    // The following seem harmless and are used by default: ['O', 'n', 'd', 'o', 'r', 's', 't', 'b', 'j']
    // To discover more, go to https://github.com/webpack/webpack/blob/main/lib/RuntimeGlobals.js and/or look at implementations here https://github.com/webpack/webpack/tree/main/lib/runtime/
    // Looking at the runtime chunk in the built bundle is probably the fastest way to learn what these do.

    const supportedRuntimeItems = ['O', 'n', 'd', 'o', 'r', 's', 't', 'b', 'j']
    for (const item of supportedRuntimeItems) {
      policyRequire[item] = harden(__webpack_require__[item])
    }

    policyRequire.m = new Proxy(
      {},
      {
        has: (target, prop) => {
          warn(
            `A module attempted to read ${String(
              prop
            )} directly from webpack's module cache`
          )
          return false
        },
      }
    )

    // webpack rewrites regerences to `global` to `__webpack_require__.g` in the bundle
    policyRequire.g = compartmentMap.get(resourceId).globalThis

    // override nmd to limit what it can mutate
    policyRequire.nmd = ( moduleReference) =>
      moduleReference === module
        ? __webpack_require__.nmd(module)
        : moduleReference
    // override hmd to limit what it can mutate
    policyRequire.hmd = ( moduleReference) =>
      moduleReference === module
        ? __webpack_require__.hmd(module)
        : moduleReference

    overrides.__webpack_require__ = policyRequire
  }
  const runtimeHandler = assign(create(null), runtimeKit, overrides)

  // allow setting, but ignore value for /* module decorator */ module = __webpack_require__.nmd(module)
  defineProperty(runtimeHandler, 'module', {
    get: () => module,
    set: () => {},
  })
  // Make it possible to overwrite `exports` locally despite runtimeHandler being frozen
  let exportsReference = runtimeHandler.exports
  defineProperty(runtimeHandler, 'exports', {
    get: () => exportsReference,
    set: (value) => {
      exportsReference = value
    },
  })
  freeze(runtimeHandler)

  return freeze(
    assign(create(null), {
      [NAME_scopeTerminator]: stricterScopeTerminator,
      [NAME_runtimeHandler]: runtimeHandler,
      [NAME_globalThis]: compartmentMap.get(resourceId).globalThis,
    })
  )
}

// defaultExport is getting assigned to __webpack_require__._LM_
LAVAMOAT.defaultExport = freeze(lavamoatRuntimeWrapper)

        ;
        LAVAMOAT['runtime'] = module.exports;
      })();;
  __webpack_require__._LM_ = LAVAMOAT.defaultExport;
  (typeof harden !== 'undefined') && harden(__webpack_require__._LM_);;